import { render, staticRenderFns } from "./ConfigCompanyTab.vue?vue&type=template&id=60aa3196&scoped=true"
import script from "./ConfigCompanyTab.vue?vue&type=script&lang=js"
export * from "./ConfigCompanyTab.vue?vue&type=script&lang=js"
import style0 from "./ConfigCompanyTab.vue?vue&type=style&index=0&id=60aa3196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aa3196",
  null
  
)

export default component.exports